<template>
  <Dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="520px"
    :close-on-click-modal="false"
    :before-close="cancel"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="110px">
      <el-form-item label="上级标签" prop="categoryParentId">
        <el-select
          v-model="form.categoryParentId"
          placeholder="无级标签"
          style="width: 100%"
          :disabled="parentLocked"
        >
          <el-option label="无" :value="0"></el-option>
          <el-option
            v-for="item in parentOptions"
            :key="item.categoryId"
            :label="item.categoryName"
            :value="item.categoryId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标签名称" prop="categoryName">
        <el-input
          v-model.trim="form.categoryName"
          maxlength="10"
          show-word-limit
          placeholder="请输入标签名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="标签描述" prop="categoryDescription">
        <el-input
          type="textarea"
          v-model.trim="form.categoryDescription"
          :rows="3"
          maxlength="200"
          show-word-limit
          placeholder="请输入标签描述"
        ></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input-number
          v-model="form.sort"
          :min="0"
          :max="9999"
          controls-position="right"
        ></el-input-number>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button plain round size="small" @click="cancel">取 消</el-button>
      <el-button
        plain
        round
        size="small"
        type="primary"
        :loading="submitLoading"
        @click="submitForm"
        >确 定</el-button
      >
    </div>
  </Dialog>
</template>

<script>
import {
  addCourseCategory,
  updateCourseCategory
} from "@/api/content/courseCategory";

const defaultForm = () => ({
  categoryId: undefined,
  categoryName: "",
  categoryDescription: "",
  categoryParentId: 0,
  sort: 0
});

export default {
  name: "CourseCategoryForm",
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      type: "add",
      parentLocked: false,
      parentOptions: [],
      form: defaultForm(),
      rules: {
        categoryName: [
          { required: true, message: "请输入标签名称", trigger: "blur" },
          {
            pattern: /^[\u4e00-\u9fa5A-Za-z0-9_\-\s]+$/,
            message: "标签名称仅支持中文、字母、数字、空格、下划线和中划线",
            trigger: "blur"
          }
        ],
        categoryParentId: [
          { required: true, message: "请选择上级标签", trigger: "change" }
        ],
        categoryDescription: [
          { max: 200, message: "标签描述不能超过200个字符", trigger: "blur" }
        ],
        sort: [
          { required: true, message: "请输入排序", trigger: "change" },
          {
            type: "number",
            min: 0,
            max: 9999,
            message: "排序范围为0~9999",
            trigger: "change"
          }
        ]
      }
    };
  },
  computed: {
    dialogTitle() {
      if (this.type === "edit") return "修改课程标签";
      if (this.form.categoryParentId) return "新增二级标签";
      return "新增一级标签";
    }
  },
  methods: {
    open(type, row = {}, parentOptions = []) {
      this.type = type;
      this.parentOptions = parentOptions || [];
      this.dialogVisible = true;
      if (type === "edit" && row.categoryId != null) {
        this.parentLocked = true;
        this.form = {
          categoryId: row.categoryId,
          categoryName: row.categoryName || "",
          categoryDescription: row.categoryDescription || "",
          categoryParentId:
            row.categoryParentId != null ? Number(row.categoryParentId) : 0,
          sort: row.sort != null ? row.sort : 0
        };
      } else {
        this.parentLocked = row.categoryParentId != null;
        this.form = {
          ...defaultForm(),
          categoryParentId:
            row.categoryParentId != null ? Number(row.categoryParentId) : 0
        };
      }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
    },
    async submitForm() {
      if (this.submitLoading) return;
      try {
        await this.$refs.formRef.validate();
      } catch (e) {
        return;
      }
      this.submitLoading = true;
      const request = this.form.categoryId
        ? updateCourseCategory
        : addCourseCategory;
      try {
        await request(this.form);
        this.$message.success(this.form.categoryId ? "修改成功" : "新增成功");
        this.cancel();
        this.$emit("success");
      } catch (e) {
      } finally {
        this.submitLoading = false;
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.form = defaultForm();
      this.parentLocked = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/CourseCategory/CourseCategoryForm.vue